import { Box, Grid, GridItem, Link } from '@gusto/workbench';
import { useSearchParams } from 'react-router-dom';
import track from './track';

const AccountAlreadyExistsCard = () => {
  const [searchParams] = useSearchParams();

  const buildURLWithParams = (route: string): string => {
    const { protocol, host } = window.location;
    const url = `${protocol}//app.${host}`.replace(':3001', ':3000');

    const queryString = searchParams.toString();
    if (queryString) {
      return `${url}${route}?${queryString}`;
    }
    return `${url}${route}`;
  };

  const existingUsersOptions = [
    {
      body: 'Create a new company using the same email address as your existing Gusto account.',
      btnCopy: 'Add company',
      heading: 'Add a company to your existing Gusto account',
      id: 'add_company',
      link: buildURLWithParams('/add_company'),
    },
    {
      body: 'Log in to your existing Gusto account and pick up where you left off.',
      btnCopy: 'Sign in',
      heading: 'Sign in to your existing Gusto account',
      id: 'sign_in',
      link: buildURLWithParams('/login'),
    },
  ];

  return (
    <Grid
      templateColumnsMd="repeat(2, 1fr)"
      templateColumns="1fr"
      columnGap={5}
      rowGap={5}
      alignItems="stretch"
    >
      {existingUsersOptions.map(cardItem => (
        <Grid key={cardItem.id} border="1px solid #dcdcdc" borderRadius={4} padding={5}>
          <GridItem>
            <Box component="p" color="salt.1000" className="text-large-bold" marginBottom={3}>
              {cardItem.heading}
            </Box>
          </GridItem>
          <GridItem>
            <Box component="p" marginBottom={3}>
              {cardItem.body}
            </Box>
          </GridItem>
          <GridItem alignSelf="end">
            <Link
              href={cardItem.link}
              variant="primary"
              className="justify-content-end"
              onClick={() => {
                track(cardItem.id);
              }}
            >
              {cardItem.btnCopy}
            </Link>
          </GridItem>
        </Grid>
      ))}
    </Grid>
  );
};

export default AccountAlreadyExistsCard;
